import React from "react";

const ErrorMessage = ({ message }) => {
  return (
    <div className="error_container mb-3 pt-3">
      <p>{message}</p>
    </div>
  );
};

export default ErrorMessage;
